import { useEffect, useRef } from "react";
import { VideoOff, MicOff, UserRound } from "lucide-react";

export const VideoTile = ({ stream, version, muted, camOn, micOn, label, testId, accent = "#FF3B6C", small = false }) => {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current) return;
    ref.current.srcObject = null;
    ref.current.srcObject = stream || null;
  }, [stream, version]);

  return (
    <div data-testid={testId}
      className={`relative overflow-hidden bg-[#1A152E] ${small ? "rounded-2xl border-2" : "rounded-3xl border"} h-full w-full`}
      style={{ borderColor: small ? accent : "rgba(255,255,255,0.1)" }}>
      <video ref={ref} autoPlay playsInline muted={muted}
        className={`h-full w-full object-cover ${muted ? "-scale-x-100" : ""} ${camOn ? "opacity-100" : "opacity-0"}`} />
      {!camOn && (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 bg-gradient-to-br from-pink-500/20 to-purple-600/30">
          <div className={`flex items-center justify-center rounded-full ${small ? "h-10 w-10" : "h-20 w-20"}`} style={{ background: accent }}>
            <UserRound className={small ? "h-5 w-5 text-white" : "h-10 w-10 text-white"} />
          </div>
          {!small && <span className="flex items-center gap-1.5 text-sm text-muted-foreground"><VideoOff className="h-4 w-4" /> Kamera kikapcsolva</span>}
        </div>
      )}
      <div className="absolute bottom-2 left-2 flex items-center gap-1.5 rounded-full bg-black/60 px-3 py-1 text-xs font-semibold backdrop-blur">
        {!micOn && <MicOff className="h-3 w-3 text-[#FF3B6C]" />} {label}
      </div>
    </div>
  );
};
